import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export const ListadoVacacionesEditor = () => {
  const { selectedNomina, setEmpleadoSeleccionado } = useOutletContext();
  const [empleados, setEmpleados] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(50);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  function formatDate(input) {
    // Si ya es Date, úsalo directamente
    if (input instanceof Date && !isNaN(input)) {
      return input.toISOString().split("T")[0];
    }

    // Si es string tipo "dd/mm/yyyy"
    if (typeof input === "string" && input.includes("/")) {
      const [day, month, year] = input.split("/");
      const date = new Date(`${year}-${month}-${day}`);
      if (!isNaN(date)) return date.toISOString().split("T")[0];
    }

    // Intento estándar
    const date = new Date(input);
    if (!isNaN(date)) return date.toISOString().split("T")[0];
    return null;
  }
  const getData = async () => {
    try {
      const fromDate = formatDate(selectedNomina.FechaInicial);
      const toDate = formatDate(selectedNomina.FechaFinal);

      const response = await axiosPrivate.get("NOM/humandVacaciones/select", {
        params: {
          idNomina: selectedNomina.idNomina,
          fromDate: fromDate,
          toDate: toDate,
        },
      });
      const data = response.data;
      console.log(data);
      setEmpleados(data.enrichedRequests);
    } catch (error) {
      console.error("Error al obtener empleados:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina?.idNomina) return;
    getData();
  }, [selectedNomina?.idNomina]);

  const columns = [
    { field: "numero", header: "numero", sortable: true },
    { field: "nombreCompleto", header: "Nombre", sortable: true },
    { field: "nomina", header: "Nombres", sortable: true },
    { field: "amountRequested", header: "Dias de vacaciones", sortable: true },
    { field: "de", header: "Fecha inicial", sortable: true },
    { field: "al", header: "Fecha final", sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable={col.sortable}
      filter={col.filter}
    />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };
  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      {/* <label htmlFor="periodo" className="whitespace-nowrap">Filtrar por periodo:</label>
      <Dropdown
        id="periodo"
        // value={periodoSeleccionado}
        // options={periodosDisponibles}
        // onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      /> */}
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(empleados, "Vacaciones")}
      />
      <Button
        icon="pi pi-save"
        className="p-button-outlined"
        severity="info"
        label="Guardar selección"
        tooltip="Guardar empleados seleccionados"
        onClick={guardarSeleccion}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );
  const [selectedEmpleados, setSelectedEmpleados] = useState(null);

  const [rowClick, setRowClick] = useState(true);
  const toast = useRef(null);

  const guardarSeleccion = async () => {
    //const idsSeleccionados = selectedEmpleados.map((row) => row.id);
    const empleados = selectedEmpleados.map((row) => ({
      idHumand: row.id,
      numeroEmpleado: row.numero,
      diasVacaciones: row.amountRequested,
      fechaInicio: row.de,
      fechaFin: row.al,
    }));

    const payload = {
      empleados,
      idNomina: selectedNomina.idNomina,
      periodo: `${
        selectedNomina.YearPeriodo
      }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`,
    };
    console.log("Payload a enviar:", payload);
    try {
      console.log("IDs seleccionados:", selectedEmpleados);
      await axiosPrivate.post("/NOM/VacacionesPorPeriodo", payload);

      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "IDs guardados correctamente",
        life: 3000,
      });
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al guardar los datos",
        life: 3000,
      });
    }
  };
  const handleEdit = (empleado) => {
    console.log("Editar:", empleado);
    setEmpleadoSeleccionado(empleado);
    // Aquí podrías navegar a un formulario o abrir un modal
    navigate(`/editor/empleados/transferir`); // ajusta según tu ruta
  };

  const handleDelete = (falta) => {
    console.log("Eliminar:", falta);
    confirmDialog({
      message: `¿Estás seguro de eliminar el registro de "${falta.Nombre}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          await axiosPrivate.delete(`/NOM/excepciones/${falta.id}`);
          toast.current.show({
            severity: "success",
            summary: "Eliminado",
            detail: `Empleado eliminado correctamente`,
            life: 3000,
          });
          getData(); // Recargar empleados
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el empleado",
            life: 3000,
          });
        }
      },
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-arrow-circle-right"
          className="p-button-rounded p-button-secondary p-button-sm"
          onClick={() => handleEdit(rowData)}
          tooltip="Transferir a nomina"
        />
        <Button
          icon="pi pi-eye-slash"
          className="p-button-rounded p-button-help p-button-sm"
          onClick={() => handleDelete(rowData)}
          tooltip="Eliminar"
        />
      </div>
    );
  };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <Card title="Vacaciones">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />
        <DataTable
          dataKey="id"
          value={empleados}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          globalFilter={globalFilter}
          className="p-datatable-sm"
          stripedRows
          selectionMode={rowClick ? null : "checkbox"}
          selection={selectedEmpleados}
          onSelectionChange={(e) => setSelectedEmpleados(e.value)}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoVacacionesEditor;
